import clsx from 'clsx';
import { forwardRef, PropsWithChildren } from 'react';
import { BaseButton, BaseButtonProps } from './base-button';

export type OutlinedButtonProps = BaseButtonProps & {
  variant: 'outlined';
};

export const OutlinedButton = forwardRef<HTMLButtonElement, PropsWithChildren<OutlinedButtonProps>>(
  ({ children, disabled, className, ...rest }, ref) => {
    return (
      <BaseButton
        ref={ref}
        className={clsx(
          {
            'border-2 border-green-laser text-green-laser hover:border-white hover:text-white focus:border-white focus:text-white active:bg-green-forest active:border-green-laser active:text-green-laser':
              !disabled,
            'text-green-forest border-green-forest opacity-40': disabled,
          },
          className,
        )}
        disabled={disabled}
        {...rest}
      >
        {children}
      </BaseButton>
    );
  },
);
